<template>
  <div>
    <div
      style="
        background: linear-gradient(to right, #75b9ff, #1b8bff);
        font-size: 0;
      "
    >
      <van-nav-bar
        title="商品分类"
        style="background: #0000"
        left-arrow
        @click-left="onClickLeft"
      />
      <div class="searchBoxOuts">
        <div class="searchBox">
          <van-field
            v-model="keywords"
            class="inputBox"
            label
            left-icon="search"
            placeholder="商品关键词"
          />
          <el-button class="searchBtn" type="text" @click="searchBtnClick">
            搜 索
          </el-button>
        </div>
      </div>
    </div>
    <div
      style="
        display: flex;
        height: calc(100vh - 0.586667rem - 50px);
        background-color: #f7f8fa;
      "
    >
      <van-sidebar v-model="active" @change="onChange">
        <van-sidebar-item
          v-for="item of menuList"
          :key="item.id"
          :title="item.shopClassName"
        />
      </van-sidebar>
      <div
        style="
          width: calc(100% - 2.133333rem);
          text-align: left;
          background-color: #fff;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="padding: 10px 20px">商品排序</div>
          <div style="display: flex">
            <div
              style="padding: 10px 20px"
              @click="zonghe"
              :class="zong == 0 ? 'active' : ''"
            >
              综合
            </div>
            <div
              @click="oneFn"
              style="padding: 10px 20px; display: flex"
              :class="one == 0 ? 'active' : ''"
            >
              销量
              <div style="height: 10px">
                <div style="height: 6px">
                  <van-icon
                    name="arrow-up"
                    style="height: 6px"
                    :class="
                      fakeSales == 'desc'
                        ? 'active-line'
                        : fakeSales == 'asc'
                        ? 'active'
                        : ''
                    "
                  />
                </div>
                <van-icon
                  name="arrow-down"
                  style="height: 6px"
                  :class="
                    fakeSales == 'asc'
                      ? 'active-line'
                      : fakeSales == 'desc'
                      ? 'active'
                      : ''
                  "
                />
              </div>
            </div>
            <div
              @click="twoFn"
              style="padding: 10px 20px; display: flex"
              :class="two == 0 ? 'active' : ''"
            >
              价格
              <div style="height: 10px">
                <div style="height: 6px">
                  <van-icon
                    name="arrow-up"
                    style="height: 6px"
                    :class="
                      shopPrice == 'desc'
                        ? 'active-line'
                        : shopPrice == 'asc'
                        ? 'active'
                        : ''
                    "
                  />
                </div>
                <van-icon
                  name="arrow-down"
                  style="height: 6px"
                  :class="
                    shopPrice == 'asc'
                      ? 'active-line'
                      : shopPrice == 'desc'
                      ? 'active'
                      : ''
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both; text-align: left; padding: 10px" class="inBox">
          <div
            v-for="item of storeList"
            :key="item.id"
            class="itemBox"
            @click="goToDetail(item.id)"
          >
            <div class="shopImg">
              <el-image
                style="width: 100%; height: 100%"
                :src="item.shopUrl"
              ></el-image>
            </div>
            <div class="contBox">
              <div class="shopName" style="margin-top: 2px">
                {{ item.shopName ? item.shopName : "---" }}
              </div>
              <div class="shopTitle">
                {{ item.shopTitle ? item.shopTitle : "---" }}
              </div>
              <div style="margin-top: 5px; height: 22px">
                <div class="shopPrice">
                  ￥
                  <span v-if="item.shopDivideModel" style="font-size: 20px">
                    {{ item.shopDivideModel.shopPrice }}
                  </span>
                  <span v-else style="font-size: 20px">
                    {{ item.shopPrice ? item.shopPrice : 0 }}
                  </span>
                </div>
                <div class="shopNum">
                  销量：{{
                    (item.fakeSales = 0 ? item.outNumber : item.fakeSales)
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="more">
            {{
              queryForm.page >= totalPage
                ? "暂无更多数据..."
                : "加载更多数据..."
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getStoreList, getStoreTypeList } from "@/api/shopping";
  export default {
    data() {
      return {
        storeList: [],
        totalPage: 1,
        queryForm: {
          page: 1,
          size: 10,
        },
        nowTypeId: "",
        meCardNum: "",
        keywords: "",
        active: 0,
        menuList: [],
        zong: 0,
        one: 1,
        two: 1,
        fakeSales: "",
        shopPrice: "",
        fnum: 0,
        snum: 0,
      };
    },
    created() {
      if (this.$route.query.userId !== undefined) {
        localStorage.removeItem("meCardNum");
      } else {
        this.meCardNum = localStorage.getItem("meCardNum");
      }
    },
    mounted() {
      this.$nextTick(() => {
        // 监听滚动事件
        //类名为guest-info-box的div必须设置高度和 overflow-y: scroll;下面的代码才会生效
        let scrollTargetBox = document.querySelector(".inBox");
        scrollTargetBox.onscroll = () => {
          var scrollHeight = scrollTargetBox.scrollHeight; //251
          var scrollTop = scrollTargetBox.scrollTop; //0-18
          var clientHeight = scrollTargetBox.clientHeight; //233
          if (scrollHeight - clientHeight == scrollTop) {
            //滚动条滚到最底部
            if (this.queryForm.page >= this.totalPage) return;
            this.queryForm.page++;
            this.getStoreList();
          }
        };
      });
      this.getStoreTypeList();
    },
    methods: {
      zonghe() {
        this.zong = 0;
        this.one = 1;
        this.two = 1;
        this.shopPrice = "";
        this.fakeSales = "";
        this.storeList = [];
        this.getStoreList();
      },
      oneFn() {
        this.snum = 0;
        this.shopPrice = "";
        this.fnum++;
        this.zong = 1;
        this.one = 0;
        this.two = 1;
        if (this.fnum % 2 == 0) {
          this.fakeSales = "desc";
        } else {
          this.fakeSales = "asc";
        }

        this.storeList = [];
        this.getStoreList();
      },

      twoFn() {
        this.fnum = 0;
        this.fakeSales = "";
        this.snum++;
        this.zong = 1;
        this.one = 1;
        this.two = 0;
        if (this.snum % 2 == 0) {
          this.shopPrice = "desc";
        } else {
          this.shopPrice = "asc";
        }
        this.storeList = [];
        this.getStoreList();
      },

      // 获取商品类型列表
      getStoreTypeList() {
        getStoreTypeList().then((res) => {
          if (res.status) {
            //  console.log(res.data)
            this.menuList = res.data;
            this.nowTitle = this.menuList[0].shopClassName;
            this.nowTypeId = this.menuList[0].id;
            this.getStoreList();
          }
        });
      },
      // 商品详情
      goToDetail(ids) {
        localStorage.removeItem("userIds");
        localStorage.setItem("shopDetailId", ids);
        if (this.$route.query.userId !== undefined) {
          localStorage.setItem("userIds", this.$route.query.userId);
        }
        this.$router.push(`/shopDetail`);
      },
      // 商品分类切换
      onChange() {
        this.storeList = [];
        this.totalPage = 1;
        this.nowTitle = this.menuList[this.active].shopClassName;
        this.nowTypeId = this.menuList[this.active].id;
        this.getStoreList();
      },
      onClickLeft() {
        history.back();
      },
      searchBtnClick() {
        this.storeList = [];
        this.totalPage = 1;
        this.queryForm.page = 1;
        this.getStoreList();
      },
      // 获取商品分页列表
      getStoreList() {
        let params = {};
        // console.log(this.$route.query.userId);
        if (this.$route.query.userId == undefined) {
          if (this.zong == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              card: this.meCardNum,
              sortName: "",
              sortType: "",
            };
          } else if (this.one == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              card: this.meCardNum,
              sortName: "fakeSales",
              sortType: this.fakeSales,
            };
          } else if (this.two == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              card: this.meCardNum,
              sortName: "shopPrice",
              sortType: this.shopPrice,
            };
          }
        } else {
          if (this.zong == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              userId: this.$route.query.userId,
              sortName: "",
              sortType: "",
            };
          } else if (this.one == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              userId: this.$route.query.userId,
              sortName: "fakeSales",
              sortType: this.fakeSales,
            };
          } else if (this.two == 0) {
            params = {
              shopClassId: this.nowTypeId,
              shopName: this.keywords,
              userId: this.$route.query.userId,
              sortName: "shopPrice",
              sortType: this.shopPrice,
            };
          }
        }

        getStoreList(this.queryForm, params).then((res) => {
          if (res.status) {
            //  console.log(res.data)
            if (res.data && res.data.list && res.data.list.length) {
              this.storeList = [...this.storeList, ...res.data.list];
              this.totalPage = res.data.totalPage;
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
  .inBox {
    padding: 0px 10px 0px;
    overflow-x: auto;
  }
  .van-sidebar {
    height: calc(100vh - 0.586667rem - 50px);
  }
  .van-nav-bar .van-icon {
    color: #fff;
  }
  .van-nav-bar__title {
    color: #fff;
  }

  * {
    margin: 0;
    padding: 0;
  }
</style>

<style lang="scss" scoped>
  .active {
    color: #1a8aff;
  }
  .active-line {
    color: #000;
  }
  .itemBox {
    margin: 10px 0px;
    height: 60px;
    padding: 0px 0px 10px;
    border-bottom: 1px solid #f5f5f5;
    .shopImg {
      float: left;
      width: 60px;
      height: 60px;
      margin-right: 5px;
      border-radius: 10px;
      overflow: hidden;
      // border: 1px solid #979797;
    }
    .contBox {
      float: right;
      width: calc(100% - 65px);
      .shopName {
        font-size: 12px;
        font-weight: bold;
        color: #4f4f4f;
        margin-bottom: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
      .shopTitle {
        color: #979797;
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
      .shopPrice {
        float: left;
        color: #1b8bff;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 45%;
      }
      .shopNum {
        float: right;
        margin-top: 3px;
        color: #979797;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 42%;
      }
    }
  }
  .more {
    clear: both;
    text-align: center;
    color: #1b8bff;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .searchBoxOuts {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: linear-gradient(to right, #75b9ff, #1b8bff);
  }
  .searchBox {
    height: 33px;
    border-radius: 5px;
    background-color: #fff;
    .inputBox {
      float: left;
      width: calc(100% - 1.9rem);
      height: 33px;
      line-height: 33px;
      border: none;
      border-radius: 15px;
      overflow: hidden;
      padding: 0px 0.133rem;
    }
  }
  .inputBox >>> .el-input__inner {
    -webkit-appearance: none;
    border: 0px !important;
    background: transparent !important;
  }
  .searchBtn {
    float: right;
    width: 1.6rem;
    margin-left: 5px;
    height: 33px;
    line-height: 0.1rem;
    text-align: center;
    overflow: hidden;
    color: #000;
    padding: 0px;
    font-size: 12px;
  }
</style>
